import { Widget } from '@typeform/embed-react';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const Iframe = styled(Widget)`
  width: 100%;
  height: ${pxToRem(500)};
`;
